'use strict';

import { get } from '@radar-ui/objects';
import i18nEn from './locales/details_page.en.yml';
import headeri18nEn from './locales/header.en.yml';

const ENTranslation = Object.assign({}, i18nEn.en, headeri18nEn.en);
export default window.I18n = {
    t: function (key, variables) {
        // Get the translation entry
        let translationEntry = get(ENTranslation, key),
            translationString;

        // If the translation is a translation object instead of string...
        if (typeof translationEntry == 'object') {
            // Find the correct translationString according to the rules
            // cf. https://guides.rubyonrails.org/i18n.html#pluralization
            switch (variables.count) {
                case 0:
                    translationString = translationEntry.zero || translationEntry.other;
                    break;
                case 1:
                    translationString = translationEntry.one || translationEntry.other;
                    break;
                default:
                    translationString = translationEntry.other;
                    break;
            }
        } else {
            // translationEntry is a string
            translationString = translationEntry;
        }

        if (!!variables) {
            const variableStrings = Object.getOwnPropertyNames(variables);
            variableStrings.forEach(variableKey => {
                translationString = translationString.replace(`%{${variableKey}}`, variables[variableKey]);
            });
        }

        return translationString;
    }
};
